import { State } from "@store/types";
import { UserPermissionsStateProps } from "./reducers";

export function getPageSize(state: State): number {
  return state.insights_userPermissions.pageSize;
}

export function getUserPermissionsStateProps(state: State): UserPermissionsStateProps {
  return state.get("insights_userPermissions");
}